exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-cell{padding-left:0!important;padding-right:0!important;text-align:center}.overflow-cell.ag-cell-focus{border-color:transparent!important}", ""]);

// exports
